import { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";

export const MID_AD_SRC =
  "//relieved-understanding.com/bOX.VvsudVGUlo0/YsWqcR/weumN9QumZbUklQkVPqTacEzuNKTfcA0-OZDuUFtONJzmMI1AN/zKQ/4/OvQJ";
export const VIDEO_AD_SRC =
  "//relieved-understanding.com/bcX/V/s.dwGhlz0/Y-Wtcs/Dekmk9EumZzUkl/koPoT/cazfNQToc/1nMlDaEstfNazWMD1RNMzmUHwYNnQv";

const PLACEMENTS = {
  mid: {
    src: MID_AD_SRC,
    testId: "cdr-mid-ad",
    label: "Middle advertisement",
    minHeight: { xs: 100, sm: 120 },
    maxWidth: 970,
  },
  end: {
    src: VIDEO_AD_SRC,
    testId: "cdr-end-ad",
    label: "Video advertisement",
    minHeight: { xs: 220, sm: 320 },
    maxWidth: 760,
  },
};

export default function CdrBannerAd({ placement = "mid" }) {
  const containerRef = useRef(null);
  const config = PLACEMENTS[placement] || PLACEMENTS.mid;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const script = document.createElement("script");
    script.settings = {};
    script.src = config.src;
    script.async = true;
    script.referrerPolicy = "no-referrer-when-downgrade";
    container.appendChild(script);
    return () => {
      if (container.contains(script)) container.removeChild(script);
    };
  }, [config.src]);

  return (
    <Box
      data-testid={config.testId}
      aria-label={config.label}
      sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", overflow: "hidden", my: { xs: 1.5, sm: 2.5 } }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>Advertisement</Typography>
      <Box ref={containerRef} sx={{ minHeight: config.minHeight, width: "100%", maxWidth: config.maxWidth, mx: "auto" }} />
    </Box>
  );
}
